import React from 'react'
import { X } from 'lucide-react'
import { FileUpload } from '../FileUpload'

interface UploadBatchModalProps {
  isOpen: boolean
  onClose: () => void
  onUploadSuccess?: (batchId: number) => void
  onUploadError?: (error: unknown) => void
}

export const UploadBatchModal: React.FC<UploadBatchModalProps> = ({
  isOpen,
  onClose,
  onUploadSuccess,
  onUploadError,
}) => {
  if (!isOpen) return null

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4 sm:p-6'>
      <div className='bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto border border-slate-200 relative'>
        <div className='flex items-center justify-between px-4 py-3 sm:px-6 sm:py-4 border-b border-slate-200'>
          <div className='min-w-0 pr-2'>
            <h2 className='text-base sm:text-lg font-semibold text-slate-900'>
              Upload New Batch
            </h2>
            <p className='text-xs text-slate-500 mt-0.5'>
              Drop your Excel file or click below to browse. Supported: .xlsx
            </p>
          </div>
          <button
            type='button'
            onClick={onClose}
            className='flex-shrink-0 p-2 rounded-full hover:bg-slate-100 text-slate-500 hover:text-slate-700 transition-colors'
            aria-label='Close'
          >
            <X className='w-4 h-4' />
          </button>
        </div>

        <div className='px-4 py-4 sm:px-6 sm:py-6'>
          <FileUpload
            onUploadSuccess={batchId => {
              try {
                onUploadSuccess?.(batchId)
              } catch (err) {
                onUploadError?.(err)
              }
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default UploadBatchModal
